// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import React from 'react';
import '../stylesheets/application.scss';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
require('@rails/ujs').start();
// require("turbolinks").start()
require('@rails/activestorage').start();
require('channels');
// require('dataTables/jquery.dataTables')
require('datatables.net-bs4');
require('datatables.net-fixedcolumns'); //( window, $ );
// require('datatables.net-fixedcolumns-bs4' )( $ );
import { createRoot } from 'react-dom/client';
import 'bootstrap';
import ChatContainer from '../components/Chat/ChatContainer';
var jQuery = require('jquery');
import toastr from 'toastr';
import DashBoard from '../components/dashboard/page';
import SettingPage from '../components/setting/page';
import StiDocumentsPage from '../components/sti-documents/page';
import DatePostsPage from '../components/date-posts/page';
import AdminMessagesPage from '../components/admin-messages/page';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import UserListPage from '../components/users/page';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/ja';
import { BrowserRouter } from 'react-router-dom';
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(isSameOrAfter);
dayjs.extend(weekOfYear);
dayjs.extend(weekday);
dayjs.extend(localeData);
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
global.toastr = toastr;
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2
        }
    }
});
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('react-message-chat');
    if (container) {
        const root = createRoot(container);
        root.render(/*#__PURE__*/ React.createElement(ChatContainer, null));
    }
    const dashboardContainer = document.getElementById('react-dashboard');
    if (dashboardContainer) {
        const root = createRoot(dashboardContainer);
        root.render(/*#__PURE__*/ React.createElement(QueryClientProvider, {
            client: queryClient
        }, /*#__PURE__*/ React.createElement(DashBoard, null)));
    }
    const userListContainer = document.getElementById('react-user-list');
    if (userListContainer) {
        const root = createRoot(userListContainer);
        root.render(/*#__PURE__*/ React.createElement(BrowserRouter, null, /*#__PURE__*/ React.createElement(QueryClientProvider, {
            client: queryClient
        }, /*#__PURE__*/ React.createElement(UserListPage, null))));
    }
    const settingPageContainer = document.getElementById('react-setting-page');
    if (settingPageContainer) {
        const root = createRoot(settingPageContainer);
        root.render(/*#__PURE__*/ React.createElement(QueryClientProvider, {
            client: queryClient
        }, /*#__PURE__*/ React.createElement(SettingPage, null)));
    }
    const stiDocumentsContainer = document.getElementById('react-sti-documents-page');
    if (stiDocumentsContainer) {
        const root = createRoot(stiDocumentsContainer);
        root.render(/*#__PURE__*/ React.createElement(QueryClientProvider, {
            client: queryClient
        }, /*#__PURE__*/ React.createElement(StiDocumentsPage, null)));
    }
    const datePostsContainer = document.getElementById('react-date-posts-page');
    if (datePostsContainer) {
        const root = createRoot(datePostsContainer);
        root.render(/*#__PURE__*/ React.createElement(QueryClientProvider, {
            client: queryClient
        }, /*#__PURE__*/ React.createElement(DatePostsPage, null)));
    }
    const adminMessagesContainer = document.getElementById('react-admin-messages-page');
    if (adminMessagesContainer) {
        const root = createRoot(adminMessagesContainer);
        root.render(/*#__PURE__*/ React.createElement(QueryClientProvider, {
            client: queryClient
        }, /*#__PURE__*/ React.createElement(AdminMessagesPage, null)));
    }
    // const surveyContainer = document.getElementById('react-survey-list');
    // if (surveyContainer) {
    //   const root = createRoot(surveyContainer);
    //   root.render(
    //     <QueryClientProvider client={queryClient}>
    //       <SurveyPage />
    //     </QueryClientProvider>,
    //   );
    // }
});
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
